import { createVNode, render } from 'vue';
import { TIME_SNACKBAR_MEDIUM } from 'app/timings';
import AppSnackbar from 'module/snackbar/AppSnackbar.vue';

const HIDE_TIMEOUT = 300;

let snackbarInstance;
let snackbarVNode;
let hideTimeout;
let unmountTimeout;

function mountSnackbar(props) {
    if (!snackbarInstance) {
        snackbarInstance = document.createElement('div');
        snackbarInstance.classList.add('l-master__snackbar');
        document.querySelector('.l-master')?.appendChild(snackbarInstance);
    }

    snackbarVNode = createVNode(AppSnackbar, props);
    render(snackbarVNode, snackbarInstance);
}

export function clearSnackbar() {
    if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
    }

    if (!snackbarVNode?.props?.displayed) {
        return;
    }

    if (snackbarInstance) {
        mountSnackbar({
            ...((snackbarVNode && snackbarVNode?.props) || {}),
            displayed: false,
        });

        unmountTimeout = setTimeout(() => {
            render(null, snackbarInstance);
            unmountTimeout = null;
        }, TIME_SNACKBAR_MEDIUM);
    }
}

export function showSnackbar(props = {}) {
    if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
    }

    if (unmountTimeout) {
        clearTimeout(unmountTimeout);
        unmountTimeout = null;
    }

    mountSnackbar({
        ...props,
        displayed: true,
    });

    hideTimeout = setTimeout(() => {
        clearSnackbar();
    }, HIDE_TIMEOUT);
}
